<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Countries'"
        :buttons="[
          {
            title: 'Add Country',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
      ></cardHead>
      <dataTable
        :name="'Countries'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updateShow = { ...$event }"
        @remove="remove"
      ></dataTable>
      <upsert
        v-if="addShow || updateShow != null"
        :setModel="updateShow"
        @add="$refs.agGrid.addRow([$event])"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="
          addShow = false;
          updateShow = null;
        "
      ></upsert>
    </div>
  </div>
</template>

<script>
import upsert from "./upsert";
export default {
  name: "Countries",
  components: { upsert },
  data() {
    return {
      data: null,
      addShow: false,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "ISO2",
          field: "ISO2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "ISO3",
          field: "ISO3",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "CurrencyCode",
          field: "CurrencyCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "LanguageCode",
          field: "LanguageCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 160,
        },
        {
          headerName: "SletatId",
          field: "SletatId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: {
            _custom: {
              type: "component-definition",
              display: "BtnCellRenderer",
              tooltip: "Component definition",
              file: "src/components/dataTable/btn-cell-renderer.vue",
            },
          },
          cellRendererParams: {
            clicked: {
              _custom: {
                type: "function",
                display: "<span>f</span> clicked(field)",
                _reviveId: 11674,
              },
            },
          },
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to delete " + item.Name + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Languages/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The country was successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
